var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "12 10 16.01 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 10h10.004L28 15.003V29a1 1 0 0 1-1 1H13a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#CC4B4C",
    stroke: "#CE4A49",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.084 22.91h-.746v-4.497h1.317c.195 0 .388.03.578.091.19.061.362.153.513.275.151.121.274.27.367.442.093.173.14.367.14.583 0 .228-.04.434-.118.62a1.295 1.295 0 0 1-.33.467c-.14.126-.31.223-.51.292-.198.07-.418.104-.658.104h-.553v1.624Zm0-3.942v1.782h.684c.09 0 .18-.015.27-.046.09-.03.171-.08.246-.15a.73.73 0 0 0 .18-.29 1.35 1.35 0 0 0 .037-.713.725.725 0 0 0-.398-.494 1.02 1.02 0 0 0-.46-.089h-.559Zm6.743 1.569c0 .37-.04.686-.122.949a2.34 2.34 0 0 1-.307.66 1.566 1.566 0 0 1-.42.417 2.119 2.119 0 0 1-.45.23c-.145.05-.278.083-.398.097-.12.014-.21.02-.267.02h-1.734v-4.497h1.38c.385 0 .724.06 1.016.18a1.982 1.982 0 0 1 1.159 1.158c.095.255.143.517.143.786Zm-2.212 1.837c.505 0 .87-.159 1.093-.476.224-.318.336-.777.336-1.38 0-.187-.023-.372-.069-.555a1.18 1.18 0 0 0-.264-.497 1.394 1.394 0 0 0-.531-.36c-.224-.092-.514-.138-.87-.138h-.435v3.406h.74Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.666 18.968v1.416h1.914v.5h-1.914v2.027h-.758v-4.498h2.865v.555z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24 15.01h4.007L23 10v4.01a1 1 0 0 0 1 1Z",
    fill: "#CED2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 10h10.004L28 15.003V29a1 1 0 0 1-1 1H13a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1Z",
    stroke: "#CED2D2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.249a46dcabadc30bd6cda70b7547aaa3.svg";
export { ForwardRef as ReactComponent };